import { mapLocaleAliasToSupportedLocale, SupportedLocale } from '@heidi/utils/i18n';

/**
 * The affiliate referral programme is paused for the Japanese market while its
 * local incentive mechanics are reviewed (LOC-320).
 */
export const isReferralProgramAvailableForLocale = (locale?: string | null): boolean => {
  if (!locale) return true;

  return mapLocaleAliasToSupportedLocale(locale) !== SupportedLocale.JaJp;
};
